var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMore3Dot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5948_85129",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 4,
    width: 4,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.52539C12.8684 7.52539 13.5 6.89381 13.5 6.02539C13.5 5.15697 12.7895 4.52539 12 4.52539C11.1316 4.52539 10.5 5.15697 10.5 6.02539C10.5 6.89381 11.2105 7.52539 12 7.52539ZM12 10.7754C11.1316 10.7754 10.5 11.407 10.5 12.2754C10.5 13.1438 11.2105 13.7754 12 13.7754C12.8684 13.7754 13.5 13.1438 13.5 12.2754C13.5 11.407 12.8684 10.7754 12 10.7754ZM10.5 18.5254C10.5 17.657 11.1316 17.0254 12 17.0254C12.8684 17.0254 13.5 17.657 13.5 18.5254C13.5 19.3938 12.8684 20.0254 12 20.0254C11.2105 20.0254 10.5 19.3938 10.5 18.5254Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5948_85129)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.275391,
    width: 24,
    height: 24,
    fill: "#010101"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore3Dot);
export default __webpack_public_path__ + "static/media/More_3 dot.381a5f20a9656b64c607feecde1a6a21.svg";
export { ForwardRef as ReactComponent };